<template>
<div class="container" v-if="$i18n.locale == 'it'">
    <div class="row">
        <div class="col s12 left-align">
        <h3>
            Cosa è il codica attività?
        </h3>
        Il codice attività indica il tipo di attività al quale afferiscono la marca ed il logo che si registrano.

        <b>
            Per capire quale sia il codice corretto per la sua attività consulti la classificazione di Nizza, riportata qui sotto.
        </b>
        <h3>
            <span id="Prodotti-Classi-Nizza">Prodotti Classi Nizza</span>
        </h3>
        <h4>Classe 1</h4>
            <ul class="browser-default"> 
                <li>
                    Prodotti chimici destinati all’industria, alle scienze, alla fotografia, come anche all’agricoltura, all’orticoltura e alla silvicoltura;
                </li> 
                <li>
                    Resine artificiali allo stato grezzo, materie plastiche allo stato grezzo;
                </li> 
                <li>
                    Composizioni per estinguere il fuoco e per prevenire gli incendi;
                </li> 
                <li>
                    Preparati per la tempera e la saldatura dei metalli;
                </li> 
                <li>
                    Sostanze concianti per pelli di animali e pellame;
                </li> 
                <li>
                    Adesivi destinati all’industria;
                </li> 
                <li>
                    Mastici e altri riempitivi di pasta;
                </li> 
                <li>
                    Composto, concimi e fertilizzanti;
                </li> 
                <li>
                    Preparati biologici destinati all’industria ed alla scienza.
                </li>
            </ul>
            <h4>Classe 2</h4>
            <ul class="browser-default"> 
                <li>Pitture, vernici, lacche;</li> 
                <li>Prodotti preservanti dalla ruggine e dal deterioramento del legno;</li> 
                <li>Coloranti, tinte;</li> 
                <li>Inchiostri per la stampa, la marcatura e l’incisione;</li> 
                <li>Resine naturali allo stato grezzo;</li> 
                <li>Metalli in fogli e in polvere per pittori, decoratori, tipografi e artisti.</li>
            </ul>
            <h4>Classe 3</h4>
            <ul class="browser-default"> 
                <li>Cosmetici e preparati per la toeletta non medicati;</li> 
                <li>Dentifrici non medicati;</li> 
                <li>Profumeria, olii essenziali;</li> 
                <li>Preparati per la sbianca e altre sostanze per il bucato;</li> 
                <li>Preparati per pulire, lucidare, sgrassare e abradere.</li>
            </ul>
            <h4>Classe 4</h4>
            <ul class="browser-default"> 
                <li>Oli e grassi industriali, cera;</li> 
                <li>Lubrificanti;</li> 
                <li>Prodotti per assorbire, bagnare e legare la polvere;</li> 
                <li>Combustibili e materie illuminanti;</li> 
                <li>Candele e stoppini per l’illuminazione.</li>
            </ul>
            <h4>Classe 5</h4>
            <ul class="browser-default"> 
                <li>Prodotti farmaceutici, preparati medici e veterinari;</li> 
                <li>Prodotti igienici per scopi medici;</li> 
                <li>Alimenti e sostanze dietetiche per uso medico o veterinario, alimenti per neonati;</li> 
                <li>Complementi alimentari per esseri umani e per gli animali;</li> 
                <li>Impiastri, materiale per fasciature;</li> 
                <li>Materiali per otturare i denti e per impronte dentarie;</li> 
                <li>Disinfettanti;</li> 
                <li>Prodotti per la distruzione degli animali nocivi</li> 
                <li>Fungicidi, erbicidi.</li>
            </ul>
            <h4>Classe 6</h4>
            <ul class="browser-default"> 
                <li>Metalli comuni e loro leghe, minerali;</li> 
                <li>Materiali da costruzione metallici;</li> 
                <li>Costruzioni trasportabili metalliche;</li> 
                <li>Cavi e fili metallici non elettrici;</li> 
                <li>Piccoli articoli di chincaglieria metallica;</li> 
                <li>Contenitori metallici per immagazzinamento o di trasporto</li> 
                <li>Casseforti.</li>
            </ul>
            <h4>Classe 7</h4>
            <ul class="browser-default"> 
                <li>Macchine, macchine-utensili, utensili a corrente;</li> 
                <li>Motori, eccetto quelli per veicoli terrestri;</li> 
                <li>Giunti e organi di trasmissione, eccetto quelli per veicoli terrestri;</li> 
                <li>Strumenti agricoli tranne attrezzi azionati manualmente;</li> 
                <li>Incubatrici per uova;</li> 
                <li>Distributori automatici.</li>
            </ul>
            <h4>Classe 8</h4>
            <ul class="browser-default"> 
                <li>Utensili e strumenti azionati manualmente;</li> 
                <li>Articoli di coltelleria, forchette e cucchiai;</li> 
                <li>Armi bianche;</li> 
                <li>Rasoi.</li>
            </ul>
            <h4>Classe 9</h4>
            <ul class="browser-default"> 
                <li>Apparecchi e strumenti scientifici, di ricerca, di navigazione, geodetici, fotografici, cinematografici, audiovisivi, ottici, di pesata, di misura, di segnalazione, di rilevamento, di collaudo, di ispezione, di salvataggio e d’insegnamento;</li> 
                <li>Apparecchi e strumenti per la conduzione, distribuzione, trasformazione, accumulazione, regolazione o controllo della distribuzione o del consumo dell’elettricità;</li> 
                <li>Apparecchi e strumenti per la registrazione, la trasmissione, la riproduzione o il trattamento dei suoni, delle immagini o dei dati;</li> 
                <li>Supporti registrati o scaricabili, computer software, supporti digitali o analogici vergini per la registrazione e la conservazione;</li> 
                <li>Meccanismi per apparecchi di prepagamento;</li> 
                <li>Registratori di cassa, macchine calcolatrici;</li> 
                <li>Computer e dispositivi periferici per computer;</li> 
                <li>Mute da sub, maschere per sub, tappi per orecchie per sub, pinze per subacquei e nuotatori, guanti per sub, autorespiratori per nuoto subacqueo;</li> 
                <li>Estintori.</li>
            </ul>
            <h4>Classe 10</h4>
            <ul class="browser-default"> 
                <li>Apparecchi e strumenti chirurgici, medici, dentari e veterinari;</li> 
                <li>Membra, occhi e denti artificiali;</li> 
                <li>Articoli ortopedici;</li> 
                <li>Materiali di sutura;</li> 
                <li>Dispositivi terapeutici e di assistenza adattati per persone disabili;</li> 
                <li>Apparecchi per il massaggio;</li> 
                <li>Apparecchi, dispositivi ed articoli di puericultura;</li> 
                <li>Apparecchi, dispositivi e articoli per le attività sessuali.</li>
            </ul>
            <h4>Classe 11</h4>
            <ul class="browser-default"> 
                <li>Apparecchi ed installazioni per illuminazione, riscaldamento, raffreddamento, produzione di vapore, cottura, essiccamento, ventilazione, distribuzione di acqua e impianti sanitari.</li>
            </ul>
            <h4>Classe 12</h4>
            <ul class="browser-default"> 
                <li>Veicoli;</li> 
                <li>Apparecchi di locomozione terrestri, aerei o nautici.</li>
            </ul>
            <h4>Classe 13</h4>
            <ul class="browser-default"> 
                <li>Armi da fuoco;</li> 
                <li>Munizioni e proiettili;</li> 
                <li>Esplosivi;</li> 
                <li>Fuochi d’artificio.</li>
            </ul>
            <h4>Classe 14</h4>
            <ul class="browser-default"> 
                <li>Metalli preziosi e loro leghe;</li> 
                <li>Gioielleria, bigiotteria, pietre preziose e semipreziose;</li> 
                <li>Orologeria e strumenti cronometrici.</li>
            </ul>
            <h4>Classe 15</h4>
            <ul class="browser-default"> 
                <li>Strumenti musicali;</li> 
                <li>Leggii e supporti per strumenti musicali;</li> 
                <li>Bacchette per battere tempo.</li>
            </ul>
            <h4>Classe 16</h4>
            <ul class="browser-default"> 
                <li>Carta e cartone;</li> 
                <li>Stampati;</li> 
                <li>Articoli per legataria;</li> 
                <li>Fotografie;</li> 
                <li>Cartoleria e articoli per ufficio, tranne i mobili;</li> 
                <li>Adesivi (materie collanti) per la cartoleria o per uso domestico;</li> 
                <li>Materiale per il disegno e materiale per artisti;</li> 
                <li>Pennelli;</li> 
                <li>Materiale per l’istruzione o l’insegnamento;</li> 
                <li>Fogli, pellicole e buste in materie plastiche per l’imballaggio e la confezione;</li> 
                <li>Caratteri tipografici, clichés.</li>
            </ul>
            <h4>Classe 17</h4>
            <ul class="browser-default"> 
                <li>Caucciù, guttaperca, gomma, amianto, mica grezzi e semi-lavorati e succedanei di tutte queste materie;</li> 
                <li>Materie plastiche e resine semilavorate utilizzate nella produzione;</li> 
                <li>Materie per turare, stoppare e isolare;</li> 
                <li>Tubi flessibili non metallici.</li>
            </ul>
            <h4>Classe 18</h4>
            <ul class="browser-default"> 
                <li>Cuoio e sue imitazioni;</li> 
                <li>Pelli di animali;</li> 
                <li>Bagagli e borse per il trasporto;</li> 
                <li>Ombrelli e ombrelloni;</li> 
                <li>bastoni da passeggio;</li> 
                <li>fruste, finimenti e selleria;</li> 
                <li>Collari, guinzagli e indumenti per animali.</li>
            </ul>
            <h4>Classe 19</h4>
            <ul class="browser-default"> 
                <li>Materiali, non di metallo, per l’edilizia e la costruzione;</li> 
                <li>Tubi rigidi non metallici per la costruzione;</li> 
                <li>Asfalto, pece, catrame e bitume;</li> 
                <li>Costruzioni trasportabili, non di metallo;</li> 
                <li>Monumenti non metallici.</li>
            </ul>
            <h4>Classe 20</h4>
            <ul class="browser-default"> 
                <li>Mobili, specchi, cornici;</li> 
                <li>Contenitori, non di metallo, per lo stoccaggio o per il trasporto;</li> 
                <li>Osso, corno, balena o madreperla, allo stato grezzo o semilavorato;</li> 
                <li>Conchiglie;</li> 
                <li>Spuma di mare;</li> 
                <li>Ambra gialla.</li>
            </ul>
            <h4>Classe 21</h4>
            <ul class="browser-default"> 
                <li>Utensili e recipienti per il governo della casa o la cucina;</li> 
                <li>Pentole e vasellame, eccetto forchette, coltelli e cucchiai;</li> 
                <li>Pettini e spugne;</li> 
                <li>Spazzole eccetto i pennelli;</li> 
                <li>Materiali per la fabbricazione di spazzole;</li> 
                <li>Materiale per pulizia;</li> 
                <li>Vetro grezzo o semilavorato tranne il vetro da costruzione;</li> 
                <li>Vetreria, porcellana e maiolica.</li>
            </ul>
            <h4>Classe 22</h4>
            <ul class="browser-default"> 
                <li>Corde e stringhe;</li> 
                <li>Reti;</li> 
                <li>Tende, tende da sole;</li> 
                <li>Pensiline in materie tessili o sintetiche;</li> 
                <li>Vele;</li> 
                <li>Sacchi per il trasporto o l’immagazzinaggio di merci alla rinfusa;</li> 
                <li>Materiale per imbottitura tranne la carta, il cartone, il caucciù o le materie plastiche;</li> 
                <li>Materie tessili fibrose grezze e i loro succedanei.</li>
            </ul>
            <h4>Classe 23</h4>
            <ul class="browser-default"> 
                <li>Fili per uso tessile.</li>
            </ul>
            <h4>Classe 24</h4>
            <ul class="browser-default"> 
                <li>Tessuti e loro succedanei;</li> 
                <li>Biancheria da casa;</li> 
                <li>Tende in materia tessile o in materia plastica.</li>
            </ul>
            <h4>Classe 25</h4>
            <ul class="browser-default"> 
                <li>Articoli di abbigliamento, scarpe, cappelleria.</li>
            </ul>
            <h4>Classe 26</h4>
            <ul class="browser-default"> 
                <li>Merletti, pizzi e ricami, nastri e lacci;</li> 
                <li>Bottoni, ganci e occhielli, spille e aghi;</li> 
                <li>Fiori artificiali;</li> 
                <li>Decorazioni per capelli;</li> 
                <li>Capelli finti.</li>
            </ul>
            <h4>Classe 27</h4>
            <ul class="browser-default"> 
                <li>Tappeti, zerbini, stuoie, linoleum e altri rivestimenti per pavimenti;</li>
                <li>Tappezzerie non in materie tessili.</li>
            </ul>
            <h4>Classe 28</h4>
            <ul class="browser-default"> 
                <li>Giochi, giocattoli;</li> 
                <li>Apparecchi di videogiochi;</li> 
                <li>Articoli per la ginnastica e lo sport;</li> 
                <li>Decorazioni per alberi di natale.</li>
            </ul>
            <h4>Classe 29</h4>
            <ul class="browser-default"> 
                <li>Carne, pesce, pollame e selvaggina;</li> 
                <li>Estratti di carne;</li> 
                <li>Frutta e ortaggi conservati, congelati, essiccati e cotti;</li> 
                <li>Gelatine, marmellate, composte;</li> 
                <li>Uova;</li> 
                <li>Latte, formaggio, burro, yogurt e altri prodotti lattiero-caseari;</li> 
                <li>Olii e grassi per alimenti.</li>
            </ul>
            <h4>Classe 30</h4>
            <ul class="browser-default"> 
                <li>Caffè, tè, cacao e succedanei del caffè;</li> 
                <li>Riso, pasta e noodles;</li> 
                <li>Tapioca e sago;</li> 
                <li>Farine e preparati fatti di cereali;</li> 
                <li>Pane, pasticceria e confetteria;</li> 
                <li>Cioccolato;</li> 
                <li>Gelati, sorbetti e altri gelati commestibili;</li> 
                <li>Zucchero, miele, sciroppo di melassa;</li> 
                <li>Lievito, polvere per fare lievitare;</li> 
                <li>Sale, condimenti, spezie, erbe conservate;</li> 
                <li>Aceto, salse ed altri condimenti;</li> 
                <li>Ghiaccio [acqua &nbsp;ghiacciata];</li>
            </ul>
            <h4>Classe 31</h4>
            <ul class="browser-default"> 
                <li>Prodotti dell’agricoltura, dell’acquacoltura, orticoli e forestali allo stato grezzo e non trasformati;</li> 
                <li>Granaglie e sementi allo stato grezzo e non trasformati;</li> 
                <li>Frutta e ortaggi freschi, erbe aromatiche fresche;</li> 
                <li>Piante e fiori naturali;</li> 
                <li>Bulbi di piante, semi e sementi;</li> 
                <li>Animali vivi;</li> 
                <li>Prodotti alimentari e bevande per animali;</li> 
                <li>Malto.</li>
                </ul>
                <h4>Classe&nbsp; 32</h4>
                <ul class="browser-default"> <li>Birre;</li> <li>Bevande non alcoliche;</li> <li>Acque minerali e gassose;</li> <li>Bevande a base di frutta e succhi di frutta;</li> <li>Sciroppi e altri preparati non alcolici per fare bevande.</li></ul><h4>Classe 33</h4><ul class="browser-default"> <li>Bevande alcoliche (eccetto le birre);</li> <li>Preparati alcolici per fare bevande.</li></ul><h4>Classe 34</h4><ul class="browser-default"> <li>Tabacco e succedanei del tabacco;</li> <li>Articoli per fumatori;</li> <li>Fiammiferi;</li> <li>Sigarette e sigari;</li> <li>Sigarette elettroniche e vaporizzatori orali per fumatori.</li></ul><h3><span id="Servizi-Classi-Nizza">Servizi Classi Nizza</span></h3><h4>Classe 35</h4><ul class="browser-default"> <li>Pubblicità;</li> <li>Gestione, organizzazione e amministrazione di affari commerciali;</li> <li>Lavori di ufficio.</li></ul><h4>Classe 36</h4><ul class="browser-default"> <li>Servizi finanziari, monetari, bancari;</li> <li>Servizi assicurativi;</li> <li>Affari immobiliari.</li></ul><h4>Classe 37</h4><ul class="browser-default"> <li>Servizi di costruzione;</li> <li>Servizi d’installazione e di riparazione;</li> <li>Estrazioni minerarie, trivellazione relativa a petrolio e gas.</li></ul><h4>Classe 38</h4><ul class="browser-default"> <li>Servizi di telecomunicazioni.</li></ul><h4>Classe 39</h4><ul class="browser-default"> <li>Trasporto;</li> <li>Imballaggio e deposito di merci;</li> <li>Organizzazione di viaggi.</li></ul><h4>Classe 40</h4><ul class="browser-default"> <li>Trattamento di materiali.</li> <li>Riciclaggio di rifiuti e immondizia;</li> <li>Purificazione dell’aria e depurazione dell’acqua;</li> <li>Servizi di stampa;</li> <li>Conservazione degli alimenti e delle bevande.</li></ul><h4>Classe 41</h4><ul class="browser-default"> <li>Educazione;</li> <li>Formazione;</li> <li>Divertimento;</li> <li>Attività sportive e culturali.</li></ul><h4>Classe 42</h4><ul class="browser-default"> <li>Servizi scientifici e tecnologici e servizi di ricerca e progettazione ad essi relativi;</li> <li>Servizi di analisi industriale, di ricerche industriali e di disegno industriale;</li> <li>Servizi di controllo di qualità e di autenticazione;</li> <li>Progettazione e sviluppo di computer e di programmi per computer.</li></ul><h4>Classe 43</h4><ul class="browser-default"> <li>Servizi di ristorazione [alimentazione];</li> <li>Alloggi temporanei.</li></ul><h4>Classe 44</h4><ul class="browser-default"> <li>Servizi medici;</li> <li>Servizi veterinari;</li> <li>Cure d’igiene e di bellezza per l’uomo o per gli animali;</li> <li>Servizi di agricoltura, di acquacoltura, di orticoltura e di silvicoltura.</li></ul><h4>Classe 45</h4><ul class="browser-default"> <li>Servizi giuridici;</li> <li>Servizi di sicurezza per la protezione fisica di beni e di individui;</li> <li>Servizi personali e sociali resi da terzi destinati a soddisfare necessità individuali.</li></ul>
        </div>
    </div>
</div>

  <div class="container" v-if="$i18n.locale == 'es'">
    <div class="row">
      <div class="col s12 left-align">
        <h3>
          Clasificación De Niza - 11 edición, versión 2021
        </h3>
        <h3>
          <span id="Prodotti-Classi-Nizza">Lista de clases</span>
        </h3>
        <h4>Clase 1</h4>
        <ul class="browser-default">
          <li>
            El papel sensible;
          </li>
          <li>
            Los compuestos para la reparación de neumáticos;
          </li>
          <li>
            La sal de conservación que no sea para conservar alimentos;
          </li>
          <li>
            Ciertos aditivos destinados a la industria alimentaria, por ejemplo: la pectina, la lecitina, las enzimas y los conservadores químicos;
          </li>
          <li>
            Ciertos ingredientes utilizados en la fabricación de productos cosméticos y productos farmacéuticos, por ejemplo: las vitaminas, los conservadores y los antioxidantes;
          </li>
          <li>
            Ciertas materias filtrantes, por ejemplo: las sustancias minerales, las sustancias vegetales y los materiales cerámicos en partículas.
          </li>
        </ul>
        <h4>Clase 2</h4>
        <ul class="browser-default">
          <li>Las pinturas, los barnices y las lacas para la industria, la artesanía y el arte;</li>
          <li>Los diluyentes, los espesantes, los fijadores y los secantes para pinturas, barnices y lacas;</li>
          <li>Los mordientes para la madera y el cuero;</li>
          <li>Los aceites antiherrumbre y los aceites para conservar la madera;</li>
          <li>Los tintes para prendas de vestir;</li>
          <li>Los colorantes para alimentos y bebidas.</li>
        </ul>
        <h4>Clase 3</h4>
        <ul class="browser-default">
          <li>Las preparaciones de higiene en cuanto productos de tocador;</li>
          <li>Las toallitas impregnadas de lociones cosméticas;</li>
          <li>Los desodorantes para personas o animales;</li>
          <li>Las preparaciones para perfumar el ambiente;</li>
          <li>Las pegatinas decorativas para uñas;</li>
          <li>El papel de lija.</li>
          <li></li>
        </ul>
        <h4>Clase 4</h4>
        <ul class="browser-default">
          <li>Los aceites para conservar obras de albañilería y el cuero;</li>
          <li>La cera en bruto, la cera para uso industrial;</li>
          <li>La energía eléctrica;</li>
          <li>Los carburantes para motores, los biocarburantes;</li>
          <li>Los aditivos no químicos para carburantes;</li>
          <li>La madera utilizada como combustible.</li>
        </ul>
        <h4>Clase 5</h4>
        <ul class="browser-default">
          <li>Los productos de higiene personal que no sean de tocador;</li>
          <li>Los pañales para bebés y para la incontinencia</li>
          <li>Los desodorantes que no sean para personas o animales;</li>
          <li>Los champús, los jabones, las lociones y los dentífricos medicinales;</li>
          <li>Los suplementos alimenticios destinados a completar una dieta normal o a beneficiar la salud;</li>
          <li>Los sustitutos de comidas y los alimentos y bebidas dietéticos para uso médico o veterinario.</li>
        </ul>
        <h4>Clase 6</h4>
        <ul class="browser-default">
          <li>Los metales en hojas o en polvo para el procesamiento ulterior, por ejemplo: para impresoras 3D;</li>
          <li>Los materiales de construcción metálicos, por ejemplo: los materiales metálicos para vías férreas, los tubos y tuberías metálicos;</li>
          <li>Los pequeños artículos de ferretería metálicos, por ejemplo: los pernos, los tornillos, los clavos, las ruedas para muebles, los cierres para ventanas;</li>
          <li>Las construcciones y estructuras transportables metálicas, por ejemplo: las casas prefabricadas, las piscinas, las jaulas para animales salvajes, las pistas de patinaje;</li>
          <li>Ciertos productos de metales comunes no clasificados según su función o finalidad, por ejemplo: las cajas multiuso de metales comunes, las estatuas, los bustos y las obras de arte de metales comunes.</li>
        </ul>
        <h4>Clase 7</h4>
        <ul class="browser-default">
          <li>Las partes de todo tipo de motores, por ejemplo: los arranques, los silenciadores y los cilindros para motores de todo tipo;</li>
          <li>Los aparatos eléctricos de limpieza y de pulido, por ejemplo: las lustradoras de calzado eléctricas, las máquinas eléctricas para lavar alfombras y moquetas y las aspiradoras;</li>
          <li>Las impresoras 3D;</li>
          <li>Los robots industriales;</li>
          <li>Ciertos vehículos especiales no destinados al transporte, por ejemplo: las barredoras, las máquinas para construir carreteras, los buldóceres, los quitanieves, así como los trenes de rodamiento de caucho en cuanto partes de orugas de dichos vehículos.</li>
        </ul>
        <h4>Clase 8</h4>
        <ul class="browser-default">
          <li>Las herramientas que funcionan manualmente para la agricultura, la jardinería y el paisajismo;</li>
          <li>Las herramientas que funcionan manualmente para carpinteros, artistas y otros artesanos, por ejemplo: los martillos, los cinceles y los buriles;</li>
          <li>Los mangos para herramientas de mano que funcionan manualmente, tales como los cuchillos y las guadañas;</li>
          <li>Los instrumentos de mano eléctricos y no eléctricos de aseo personal y arte corporal, por ejemplo: las maquinillas de afeitar, los aparatos para rizar el cabello, los aparatos de tatuaje, así como los aparatos de manicura y pedicura;</li>
          <li>Las bombas que funcionan manualmente;</li>
          <li>Los cubiertos, tales como los cuchillos, los tenedores y las cucharas, incluidos los de metales preciosos.</li>
        </ul>
        <h4>Clase 9</h4>
        <ul class="browser-default">
          <li>Los aparatos e instrumentos de investigación científica para laboratorios;</li>
          <li>Los equipos y simuladores de entrenamiento, por ejemplo: los maniquís para ejercicios de reanimación, los simuladores de conducción y control de vehículos;</li>
          <li>Los aparatos e instrumentos de control y vigilancia de aeronaves, de vehículos náuticos y de vehículos no tripulados, por ejemplo: los instrumentos de navegación, los transmisores, los compases de medición, los aparatos de GPS (sistema mundial de determinación de la posición), los aparatos de conducción automática para vehículos;</li>
          <li>Los aparatos e instrumentos de salvamento y seguridad, por ejemplo: las redes de seguridad, las luces de señalización, los semáforos, las autobombas contra incendios, las alarmas sonoras, las fichas de seguridad en cuanto dispositivos de cifrado;</li>
          <li>Las prendas de vestir que protegen contra lesiones graves o potencialmente mortales, por ejemplo: la ropa de protección contra los accidentes, las radiaciones y el fuego, la ropa antibalas, los cascos de protección, los protectores de cabeza para deportes, los protectores bucales para deportes, los trajes especiales de protección para aviadores, las rodilleras para trabajadores;</li>
          <li>Los aparatos e instrumentos ópticos, por ejemplo: las gafas, las lentes de contacto, las lupas, los espejos de inspección para obras, las mirillas; los imanes;</li>
          <li>Los relojes inteligentes, los monitores de actividad física ponibles;</li>
          <li>Las palancas de mando (joysticks) de ordenador, que no sean para videojuegos, los cascos de realidad virtual, las gafas inteligentes;</li>
          <li>Los estuches para gafas, los estuches para teléfonos inteligentes, los estuches especiales para aparatos e instrumentos fotográficos;</li>
          <li>Los cajeros automáticos, las máquinas facturadoras, los instrumentos y máquinas para ensayos de materiales;</li>
          <li>Las baterías y los cargadores para cigarrillos electrónicos;</li>
          <li>Los dispositivos eléctricos y electrónicos de efectos para instrumentos musicales;</li>
          <li>Los robots de laboratorio, los robots pedagógicos, los robots de vigilancia para la seguridad, los robots humanoides dotados de inteligencia artificial.</li>
        </ul>
        <h4>Clase 10</h4>
        <ul class="browser-default">
          <li>Las vendas de sujeción, las vendas ortopédicas;</li>
          <li>Las prendas especiales para uso médico, por ejemplo: la ropa de compresión, las medias para varices, las camisas de fuerza, el calzado ortopédico;</li>
          <li>Los artículos, instrumentos y dispositivos para la menstruación, la anticoncepción y el parto, por ejemplo: las copas menstruales, los pesarios, los preservativos, los colchones para el parto, los fórceps;</li>
          <li>Los artículos y dispositivos terapéuticos y protésicos de materiales artificiales o sintéticos para implantación, por ejemplo: los implantes quirúrgicos compuestos de materiales artificiales, las prótesis mamarias, los marcapasos cerebrales, los implantes biodegradables de fijación ósea;</li>
          <li>Los muebles especiales para uso médico, por ejemplo: los sillones para uso médico o dental, los colchones de aire para uso médico, las mesas de operaciones.</li>
        </ul>
        <h4>Clase 11</h4>
        <ul class="browser-default">
          <li>Los aparatos e instalaciones de aire acondicionado;</li>
          <li>Los hornos que no sean de laboratorio, por ejemplo: los hornos dentales, los hornos de microondas, los hornos de panadería;</li>
          <li>Las estufas en cuanto aparatos de calefacción;</li>
          <li>Los colectores solares térmicos;</li>
          <li>Los humeros de chimenea, los tiros de chimenea, las chimeneas, las chimeneas para viviendas;</li>
          <li>Los esterilizadores, los incineradores;</li>
          <li>Los aparatos e instalaciones de alumbrado, por ejemplo: los tubos luminosos de alumbrado, los proyectores de luz, los números luminosos para casas, los reflectores para vehículos, las luces para vehículos;</li>
          <li>Las lámparas (aparatos de iluminación), por ejemplo: las lámparas eléctricas, las lámparas de gas, las lámparas de laboratorio, las lámparas de aceite, las farolas, las lámparas de seguridad;</li>
          <li>Los aparatos de bronceado;</li>
          <li>Las instalaciones de baño, los aparatos para baños;</li>
          <li>Los inodoros, los urinarios;</li>
          <li>Las fuentes, las fuentes de chocolate;</li>
          <li>Los cojines, las almohadillas y las mantas electrotérmicas que no sean para uso médico;</li>
          <li>Las bolsas de agua caliente;</li>
          <li>Las prendas de vestir electrotérmicas;</li>
          <li>Las yogurteras eléctricas, las máquinas para hacer pan, las cafeteras, las máquinas para preparar helados cremosos;</li>
          <li>Los aparatos y máquinas de hielo.</li>
        </ul>
        <h4>Clase 12</h4>
        <ul class="browser-default">
          <li>Los motores para vehículos terrestres;</li>
          <li>Los acoplamientos y elementos de transmisión para vehículos terrestres;</li>
          <li>Los aerodeslizadores;</li>
          <li>Los vehículos teledirigidos que no sean juguetes;</li>
          <li>Las partes de vehículos, por ejemplo: los parachoques, los parabrisas, los volantes, los neumáticos para ruedas de vehículos, así como las orugas para vehículos.</li>
        </ul>
        <h4>Clase 13</h4>
        <ul class="browser-default">
          <li>Las luces de bengala de emergencia explosivas o pirotécnicas;</li>
          <li>Las pistolas de bengalas;</li>
          <li>Las señales de niebla explosivas, los cohetes de señales;</li>
          <li>Las pistolas de aire comprimido en cuanto armas;</li>
          <li>Las bandoleras para armas;</li>
          <li>Las armas de fuego para cazar.</li>
        </ul>
        <h4>Clase 14</h4>
        <ul class="browser-default">
          <li>Los artículos de joyería, incluidos los artículos de bisutería, por ejemplo: el estrás;</li>
          <li>Los gemelos de camisa, los alfileres de corbata, los pasadores de corbata;</li>
          <li>Los llaveros y los dijes para llaveros;</li>
          <li>Los joyeros;</li>
          <li>Las partes constitutivas de artículos de joyería y relojería, por ejemplo: los cierres y las perlas para joyería, los movimientos de relojería, las agujas de reloj, los resortes de reloj, los cristales de reloj.</li>
        </ul>
        <h4>Clase 15</h4>
        <ul class="browser-default">
          <li>Los instrumentos musicales mecánicos y sus accesorios, por ejemplo: los organillos, los pianos mecánicos, los reguladores de intensidad para pianos mecánicos, las baterías robóticas;</li>
          <li>Las cajas de música;</li>
          <li>Los instrumentos musicales eléctricos y electrónicos;</li>
          <li>Las cuerdas, las lengüetas, las clavijas y los pedales para instrumentos musicales;</li>
          <li>Los diapasones, los afinadores de cuerdas;</li>
          <li>La colofonia para instrumentos musicales de cuerda.</li>
        </ul>
        <h4>Clase 16</h4>
        <ul class="browser-default">
          <li>Los cortapapeles;</li>
          <li>Los estuches, fundas y dispositivos para contener o proteger artículos de papel, por ejemplo: las carpetas para documentos, las pinzas para billetes, las fundas para talonarios de cheques, las pinzas para sujetar papeles, las fundas para pasaportes, los álbumes;</li>
          <li>Ciertas máquinas de oficina, por ejemplo: las máquinas de escribir, las multicopistas, las máquinas franqueadoras de oficina, las máquinas sacapuntas;</li>
          <li>Los artículos de pintura para artistas, así como para pintores de interiores y exteriores, por ejemplo: las salseras para pintura, los caballetes y paletas para pintores, los rodillos y bandejas para pintura;</li>
          <li>Ciertos productos desechables de papel, por ejemplo: los baberos, los pañuelos y las mantelerías de papel;</li>
          <li>Ciertos productos de papel o de cartón no clasificados en otras clases según su función o finalidad, por ejemplo: las bolsas, sobres y recipientes de papel para empaquetar, las estatuas, figuritas y objetos de arte de papel o cartón, tales como las figuritas de papel maché, las litografías, los cuadros o las acuarelas, enmarcados o no.</li>
        </ul>
        <h4>Clase 17</h4>
        <ul class="browser-default">
          <li>La goma para recauchutar neumáticos;</li>
          <li>Las barreras flotantes anticontaminación;</li>
          <li>Las cintas adhesivas que no sean de uso médico o doméstico, ni de papelería;</li>
          <li>Las películas de materias plásticas que no sean para empaquetar y acondicionar, por ejemplo: las películas antideslumbrantes para cristales;</li>
          <li>Los hilos elásticos y los hilos de caucho o de materias plásticas que no sean para uso textil;</li>
          <li>Ciertos productos fabricados con materiales comprendidos en esta clase, no clasificados en otras clases según su función o finalidad, por ejemplo: los soportes de gomaespuma para arreglos florales, las materias de acolchado de caucho o de materias plásticas, los tapones de caucho, los tampones amortiguadores de caucho, las bolsas o sobres de caucho para empaquetar.</li>
        </ul>
        <h4>Clase 18</h4>
        <ul class="browser-default">
          <li>Los artículos de equipaje y las bolsas de transporte, por ejemplo: las maletas, los baúles, las bolsas de viaje, las bandoleras portabebés, las mochilas escolares;</li>
          <li>Las etiquetas identificadoras para artículos de equipaje;</li>
          <li>Los tarjeteros y las billeteras;</li>
          <li>Las cajas y cajones de cuero y de cartón-cuero.</li>
        </ul>
        <h4>Clase 19</h4>
        <ul class="browser-default">
          <li>Las maderas semielaboradas para la construcción, por ejemplo: las vigas, los tablones, los paneles;</li>
          <li>Los chapados de madera;</li>
          <li>El vidrio de construcción, por ejemplo: las tejas de vidrio, el vidrio aislante para la construcción, el vidrio armado;</li>
          <li>Las microesferas de vidrio para la señalización horizontal de carreteras;
            el granito, el mármol, la grava;
          </li>
          <li>El barro cocido en cuanto material de construcción;</li>
          <li>Los techados no metálicos con células fotovoltaicas integradas;</li>
          <li>Las lápidas sepulcrales y las tumbas no metálicas;</li>
          <li>Las estatuas, los bustos y las obras de arte de piedra, hormigón o mármol;
            los buzones de correo de obra;
          </li>
          <li>Los geotextiles;</li>
          <li>Los enlucidos en cuanto materiales de construcción;</li>
          <li>Los andamios no metálicos;</li>
          <li>Las construcciones y estructuras transportables no metálicas, por ejemplo: los acuarios, las pajareras, las astas de bandera, las marquesinas, las piscinas.</li>
        </ul>
        <h4>Clase 20</h4>
        <ul class="browser-default">
          <li>Los muebles metálicos y los muebles de camping, los armeros para fusiles, los expositores para periódicos;</li>
          <li>Las persianas de interior para ventanas;</li>
          <li>Los accesorios de cama, por ejemplo: los colchones, los somieres, las almohadas;</li>
          <li>Los espejos de mobiliario y de tocador;</li>
          <li>Las placas de matriculación no metálicas;</li>
          <li>Los pequeños artículos de ferretería no metálicos, por ejemplo: los pernos, los tornillos, las clavijas, las ruedas para muebles, las abrazaderas para tuberías;</li>
          <li>Los buzones de correo no metálicos ni de obra.</li>
        </ul>
        <h4>Clase 21</h4>
        <ul class="browser-default">
          <li>Los utensilios de cocina y los utensilios para uso doméstico, por ejemplo: los matamoscas, las pinzas para la ropa, las cucharas para mezclar, los cucharones y los sacacorchos, así como los utensilios de servir, por ejemplo: las pinzas para el azúcar, las pinzas para el hielo, las palas para tartas y los cucharones de servir;</li>
          <li>Los recipientes para uso doméstico o culinario, por ejemplo: los jarrones, las botellas, las huchas de cerdito, los cubos, las cocteleras, las ollas y cazuelas, así como los hervidores y las ollas a presión no eléctricos;</li>
          <li>Los aparatos pequeños de cocina para picar, moler, exprimir o triturar, que funcionan manualmente, por ejemplo: los prensaajos, los cascanueces, los pilones y los morteros;</li>
          <li>Los salvamanteles, posabotellas y posavasos;</li>
          <li>Los utensilios de tocador y utensilios cosméticos, por ejemplo: los peines y cepillos de dientes eléctricos o no, el hilo dental, los separadores interdigitales de espuma para la pedicura, las borlas de polvera, los neceseres de tocador;</li>
          <li>Los artículos de jardinería, por ejemplo: los guantes de jardinería, las jardineras para ventanas, las regaderas y las boquillas para mangueras de riego;</li>
          <li>Los acuarios de interior, los terrarios de interior y los vivarios de interior.</li>
        </ul>
        <h4>Clase 22</h4>
        <ul class="browser-default">
          <li>Las cuerdas y cordeles de fibras textiles naturales o artificiales, de papel o de materias plásticas;</li>
          <li>Las redes de pescar, las hamacas, las escalas de cuerda;</li>
          <li>Las fundas no ajustables para vehículos;</li>
          <li>Ciertas bolsas y sacos no clasificados en otras clases según su función o finalidad, por ejemplo: las bolsas de malla para lavar la ropa, las bolsas para cadáveres, las sacas postales;</li>
          <li>Las bolsas de materias textiles para empaquetar;</li>
          <li>Las fibras de origen animal y las fibras textiles en bruto, por ejemplo: la crin, los capullos de gusanos de seda, la tela de yute, la lana tratada o en bruto, la seda en bruto.</li>
        </ul>
        <h4>Clase 23</h4>
        <ul class="browser-default">
          <li>Las fibras de vidrio, elásticas, de caucho o de materias plásticas, para uso textil;</li>
          <li>Los hilos de bordar, zurcir o coser, incluidos los hilos metálicos;</li>
          <li>La seda hilada, el algodón hilado, la lana hilada.</li>
        </ul>
        <h4>Clase 24</h4>
        <ul class="browser-default">
          <li>La ropa de hogar, por ejemplo: las colchas, las fundas de almohada, las toallas de materias textiles;</li>
          <li>La ropa de cama de papel;</li>
          <li>Los sacos de dormir, las sábanas para sacos de dormir;</li>
          <li>Los mosquiteros.</li>
        </ul>
        <h4>Clase 25</h4>
        <ul class="browser-default">
          <li>Las partes de prendas de vestir, de calzado y de artículos de sombrerería, por ejemplo: los puños, los bolsillos, los forros confeccionados, los tacones, los refuerzos de talón y las alzas de talón, las viseras para gorras, las armaduras de sombreros;</li>
          <li>Las prendas de vestir y el calzado para deporte, por ejemplo: los guantes de esquí, las camisetas de deporte sin mangas, la ropa para ciclistas, los uniformes de judo y de karate, las botas de fútbol, las zapatillas de gimnasia, las botas de esquí;</li>
          <li>Los trajes de disfraces;</li>
          <li>La ropa de papel, los sombreros de papel en cuanto prendas de vestir;</li>
          <li>Los baberos que no sean de papel;</li>
          <li>Los pañuelos de bolsillo;</li>
          <li>Los folgos que no estén calentados eléctricamente.</li>
        </ul>
        <h4>Clase 26</h4>
        <ul class="browser-default">
          <li>Las pelucas, los tupés, las barbas postizas;</li>
          <li>Los pasadores, las cintas para el cabello;</li>
          <li>Las cintas y los lazos de mercería o para el cabello, de cualquier material;</li>
          <li>Las cintas y los lazos para envolver regalos, que no sean de papel;</li>
          <li>Las redecillas para el cabello;</li>
          <li>Las hebillas, las cremalleras (cierres);</li>
          <li>Los dijes que no sean para artículos de joyería ni llaveros;</li>
          <li>Las guirnaldas y coronas de Navidad artificiales, incluidas las que comprenden luces;</li>
          <li>Ciertos artículos para rizar el cabello, por ejemplo: los bigudís eléctricos o no, las horquillas para ondular el cabello, las tiras de papel para rizar el cabello.</li>
        </ul>
        <h4>Clase 27</h4>
        <ul class="browser-default">
          <li>Las alfombrillas para automóviles;</li>
          <li>Las alfombras para cubrir suelos, por ejemplo: las alfombrillas de baño, los felpudos, las colchonetas de gimnasia, las esteras de yoga;</li>
          <li>El césped artificial;</li>
          <li>El papel pintado, incluido el papel pintado de materias textiles.</li>
        </ul>
        <h4>Clase 28</h4>
        <ul class="browser-default">
          <li>Los aparatos recreativos y de juegos, incluidos sus dispositivos de mando;</li>
          <li>Los artículos de cotillón y los artículos de broma, por ejemplo: las máscaras de carnaval, los sombreros de papel para fiestas, los confetis, los lanzadores de serpentinas y confetis para fiestas y los envoltorios sorpresa de Navidad (Christmas crackers);</li>
          <li>El material de caza y pesca, por ejemplo: las cañas de pescar, los salabardos de pesca, los señuelos, los reclamos de caza;</li>
          <li>Los aparatos para juegos y deportes diversos.</li>
        </ul>
        <h4>Clase 29</h4>
        <ul class="browser-default">
          <li>Los alimentos a base de carne, pescado, fruta o verduras, hortalizas y legumbres;</li>
          <li>Los insectos comestibles;</li>
          <li>Las bebidas lacteadas en las que predomine la leche;</li>
          <li>Los sucedáneos de la leche, por ejemplo: la leche de almendras, la leche de coco, la leche de cacahuete, la leche de arroz, la leche de soja;</li>
          <li>Los champiñones en conserva;</li>
          <li>Las leguminosas y los frutos secos preparados para la alimentación humana;</li>
          <li>Los granos preparados para la alimentación humana, que no sean productos para sazonar o aromatizantes.</li>
        </ul>
        <h4>Clase 30</h4>
        <ul class="browser-default">
          <li>Las bebidas a base de café, cacao, chocolate o té;</li>
          <li>Los cereales preparados para la alimentación humana, por ejemplo: los copos de avena, los chips de maíz, la cebada mondada, el bulgur, el muesli;</li>
          <li>Las pizzas, las tartas saladas, los sándwiches;</li>
          <li>Los frutos secos recubiertos de chocolate;</li>
          <li>Los aromatizantes, que no sean aceites esenciales, alimentarios o para bebidas.</li>
        </ul>
        <h4>Clase 31</h4>
        <ul class="browser-default">
          <li>Los cereales sin procesar;</li>
          <li>Las frutas, verduras, hortalizas y legumbres frescas, incluso lavadas o enceradas;</li>
          <li>Los residuos de origen vegetal;</li>
          <li>Las algas sin procesar;</li>
          <li>La madera sin desbastar;</li>
          <li>Los huevos fertilizados para incubar;</li>
          <li>Las trufas y los champiñones frescos;</li>
          <li>La arena higiénica para animales, por ejemplo: la arena aromática, el papel granulado para lechos de animales de compañía.</li>
        </ul>
        <h4>Clase&nbsp; 32</h4>
        <ul class="browser-default">
          <li>Las bebidas desalcoholizadas;</li>
          <li>Las bebidas refrescantes sin alcohol;</li>
          <li>Las bebidas a base de arroz y de soja, que no sean sucedáneos de la leche;</li>
          <li>Las bebidas energéticas, las bebidas isotónicas, las bebidas enriquecidas con proteínas para deportistas;</li>
          <li>Las esencias y extractos de frutas sin alcohol para elaborar bebidas.•	las esencias y extractos de frutas sin alcohol para elaborar bebidas.</li>
        </ul>
        <h4>Clase 33</h4>
        <ul class="browser-default">
          <li>Los vinos, los vinos generosos;</li>
          <li>Las sidras, la perada;</li>
          <li>Las bebidas espirituosas, los licores;</li>
          <li>Las esencias alcohólicas, los extractos de frutas alcohólicos, los amargos.</li>
        </ul>
        <h4>Clase 34</h4>
        <ul class="browser-default">
          <li>Los sucedáneos del tabaco que no sean para uso médico;</li>
          <li>Los aromatizantes, que no sean aceites esenciales, para cigarrillos electrónicos, los vaporizadores bucales para fumadores;</li>
          <li>Las hierbas para fumar;</li>
          <li>El rapé (tabaco en polvo);</li>
          <li>Ciertos accesorios y recipientes relacionados con el consumo de tabaco y artículos para fumar, por ejemplo: los encendedores para fumadores, los ceniceros para fumadores, los botes para tabaco, las tabaqueras (cajas para rapé), las cajas con humidificador para puros.</li>
        </ul>
        <h4>Clase 35</h4>
        <ul class="browser-default">
          <li>El agrupamiento, por cuenta de terceros, de una amplia gama de productos, excepto su transporte, para que los consumidores puedan verlos y adquirirlos con comodidad; estos servicios pueden ser prestados por comercios minoristas o mayoristas, distribuidores automáticos, catálogos de venta por correspondencia o medios de comunicación electrónicos tales como sitios web o programas de televenta;</li>
          <li>Los servicios de publicidad, de marketing y de promoción, por ejemplo, la distribución de muestras, el desarrollo de conceptos publicitarios, la redacción y publicación de textos publicitarios;</li>
          <li>La decoración de escaparates;</li>
          <li>Los servicios de relaciones públicas;</li>
          <li>La producción de programas de televenta;</li>
          <li>La organización de ferias comerciales y de exposiciones con fines comerciales o publicitarios;</li>
          <li>La optimización de motores de búsqueda con fines de promoción de ventas;</li>
          <li>Los servicios de asistencia comercial, por ejemplo: la selección de personal, la negociación de contratos de negocios para terceros, el análisis del precio de costo, los servicios de agencias de importación-exportación;</li>
          <li>Los servicios administrativos relativos a transacciones de negocios y registros financieros, por ejemplo: la teneduría de libros, la elaboración de estados de cuenta, las auditorías empresariales, las auditorías contables y financieras, la valoración de negocios comerciales, la preparación y la presentación de declaraciones tributarias;</li>
          <li>La gestión comercial de licencias de productos y servicios de terceros;</li>
          <li>Los servicios que comprenden el registro, la transcripción, la composición, la compilación o la sistematización de comunicaciones escritas y grabaciones, así como la compilación de datos matemáticos o estadísticos;</li>
          <li>Los trabajos de oficina, por ejemplo: los servicios de programación y de recordatorio de citas, la búsqueda de datos en archivos informáticos para terceros, los servicios de gestión informática de archivos, los servicios de centrales telefónicas.</li>
        </ul>
        <h4>Clase 36</h4>
        <ul class="browser-default">
          <li>Los servicios de pago y de transacciones financieras, por ejemplo: las operaciones de cambio, la transferencia electrónica de fondos, el procesamiento de pagos por tarjeta de crédito y de débito, la emisión de cheques de viaje;</li>
          <li>La gestión y la investigación financieras;</li>
          <li>Las estimaciones financieras, por ejemplo: la tasación de joyas, obras de arte y bienes inmuebles, la estimación financiera de costos de reparación;</li>
          <li>La verificación de cheques;</li>
          <li>Los servicios de financiación y de crédito, por ejemplo: los préstamos, la emisión de tarjetas de crédito, el arrendamiento con opción de compra;</li>
          <li>La financiación participativa;</li>
          <li>Los servicios de depósito en cajas de seguridad;</li>
          <li>El patrocinio financiero;</li>
          <li>Los servicios de agencias inmobiliarias, la administración de bienes inmuebles, el alquiler de apartamentos, el cobro de alquileres;</li>
          <li>La suscripción de seguros, los servicios actuariales;</li>
          <li>Los servicios de corretaje, por ejemplo: el corretaje de valores, de seguros, y de bienes inmuebles, el corretaje de créditos de carbono, los préstamos prendarios.</li>
        </ul>
        <h4>Clase 37</h4>
        <ul class="browser-default">
          <li>La construcción y la demolición de edificios, carreteras, puentes, presas o líneas de transmisión, así como los servicios en el ámbito de la construcción, por ejemplo: los trabajos de pintura para interiores y exteriores, los trabajos de yesería, los trabajos de fontanería, la instalación de sistemas de calefacción y los trabajos de techado;</li>
          <li>La construcción naval;</li>
          <li>El alquiler de herramientas, de máquinas y equipos de construcción, por ejemplo: el alquiler de buldóceres, el alquiler de grúas;</li>
          <li>Los diversos servicios de reparación, por ejemplo: los relacionados con la electricidad, el hardware, los muebles, los instrumentos y herramientas;</li>
          <li>Los diversos servicios de restauración, por ejemplo: la restauración de edificios, la restauración de muebles, la restauración de obras de arte;</li>
          <li>Los servicios de conservación para mantener el estado original de objetos sin alterar ninguna de sus propiedades;</li>
          <li>La limpieza de diversos objetos, por ejemplo: las ventanas, los vehículos, las prendas de vestir, así como los servicios de lavandería y el planchado de prendas de vestir.</li>
        </ul>
        <h4>Clase 38</h4>
        <ul class="browser-default">
          <li>La transmisión de archivos digitales y de mensajes de correo electrónico;</li>
          <li>El suministro de acceso de usuario a redes informáticas mundiales;</li>
          <li>La radiodifusión y la teledifusión;</li>
          <li>La transmisión de vídeo a la carta;</li>
          <li>El suministro de foros de discusión (chats) en Internet y de foros en línea;</li>
          <li>Los servicios de telefonía y de buzón de voz;</li>
          <li>Los servicios de teleconferencia y de videoconferencia.</li>
        </ul>
        <h4>Clase 39</h4>
        <ul class="browser-default">
          <li>La explotación de estaciones, puentes, ferrocarriles, transbordadores (ferris) y otras instalaciones de transporte;</li>
          <li>El alquiler de vehículos de transporte, así como los servicios de chóferes y de pilotaje;</li>
          <li>Los servicios de alquiler relacionados con el transporte, el almacenamiento y los viajes, por ejemplo: el alquiler de plazas de aparcamiento, el alquiler de garajes, el alquiler de contenedores de almacenamiento;</li>
          <li>La operación de remolcadores marítimos, la descarga de mercancías, la operación de puertos y muelles, así como el salvamento de buques siniestrados y sus cargamentos;</li>
          <li>El empaquetado, el embotellado, el embalaje y el reparto de productos;</li>
          <li>El abastecimiento de distribuidores automáticos y cajeros automáticos bancarios;</li>
          <li>Los servicios de suministro de información sobre viajes o el transporte de mercancías prestados por intermediarios y agencias de turismo, así como los servicios de suministro de información sobre tarifas, horarios y medios de transporte;</li>
          <li>La inspección de vehículos o mercancías para su transporte;</li>
          <li>La distribución de energía y electricidad, así como la distribución y suministro de agua.</li>
        </ul>
        <h4>Clase 40</h4>
        <ul class="browser-default">
          <li>La transformación de un objeto o sustancia y cualquier tratamiento que implique una modificación de sus propiedades esenciales, por ejemplo: el teñido de una prenda de vestir; estos servicios de transformación se clasifican asimismo en la clase 40 si son prestados en el marco de trabajos de reparación o mantenimiento, por ejemplo: el cromado de parachoques de vehículos;</li>
          <li>El tratamiento de materiales que puedan intervenir en el proceso de fabricación de cualquier sustancia u objeto que no sea un edificio, por ejemplo: los servicios en relación con el corte, la conformación, el pulido por abrasión o el revestimiento metálico;</li>
          <li>El ensamblaje de materiales, por ejemplo: los servicios de soldadura;</li>
          <li>El procesamiento y tratamiento de productos alimenticios, por ejemplo: el prensado de frutas, la molienda de grano, la conservación de alimentos y bebidas, el ahumado de alimentos, la congelación de alimentos;</li>
          <li>La fabricación de productos según el pedido y las especificaciones de terceros (teniendo en cuenta que ciertas oficinas exigen que se indiquen los productos fabricados), por ejemplo: la fabricación por encargo de automóviles;</li>
          <li>Los servicios de protésicos dentales;</li>
          <li>El acolchado, los servicios de bordado, los servicios de sastre, el teñido de textiles, el apresto de textiles.</li>
        </ul>
        <h4>Clase 41</h4>
        <ul class="browser-default">
          <li>La organización de exposiciones con fines culturales o educativos, la organización y la dirección de conferencias, congresos y simposios;</li>
          <li>Los servicios de traducción y de interpretación lingüística;</li>
          <li>La publicación de libros y textos, que no sean textos publicitarios;</li>
          <li>Los servicios de reporteros, los reportajes fotográficos;</li>
          <li>Los servicios fotográficos;</li>
          <li>La realización y la producción de películas no publicitarias;</li>
          <li>Los servicios culturales, educativos y recreativos prestados por parques de atracciones, circos, zoos, galerías de arte y museos;</li>
          <li>Los servicios de entrenamiento deportivo y para el mantenimiento físico;</li>
          <li>La doma y el adiestramiento de animales;</li>
          <li>Los servicios de juegos informáticos en línea;</li>
          <li>Los servicios de juegos de apuestas, la organización de loterías;</li>
          <li>La reserva de entradas y los servicios de reserva para eventos educativos, deportivos y de entretenimiento;</li>
          <li>Ciertos servicios de redacción, tales como la redacción de guiones televisivos y cinematográficos, los servicios de compositores y autores de música.</li>
        </ul>
        <h4>Clase 42</h4>
        <ul class="browser-default">
          <li>Los servicios de ingenieros y científicos encargados de efectuar evaluaciones, estimaciones, investigaciones e informes en los ámbitos científico y tecnológico, incluidos los servicios de consultoría tecnológica;</li>
          <li>Los servicios tecnológicos e informáticos sobre la seguridad de los datos informáticos y la información personal y financiera, así como la detección del acceso no autorizado a datos e información, por ejemplo: los servicios de protección antivirus (informática), los servicios de cifrado de datos, la vigilancia electrónica de información de identificación personal para detectar la usurpación de identidad por Internet;</li>
          <li>El software como servicio (SaaS), la plataforma como servicio (PaaS);</li>
          <li>Los servicios de investigación científica con fines médicos;</li>
          <li>Los servicios de arquitectura y de planificación urbana;</li>
          <li>Ciertos servicios de diseño, por ejemplo: el diseño industrial, el diseño de software y de sistemas informáticos, el diseño de interiores, los servicios de diseñadores de embalajes, el diseño de artes gráficas, el diseño de moda;</li>
          <li>Los peritajes (trabajos de ingenieros);</li>
          <li>La prospección de petróleo, gas y minería.</li>
        </ul>
        <h4>Clase 43</h4>
        <ul class="browser-default">
          <li>La reserva de alojamiento temporal, por ejemplo, la reserva de hoteles;</li>
          <li>Los servicios de residencias para animales;</li>
          <li>El alquiler de salas de reunión, tiendas de campaña y construcciones transportables;</li>
          <li>Los servicios de residencias para la tercera edad;</li>
          <li>Los servicios de guarderías infantiles;</li>
          <li>La decoración de alimentos, la escultura de alimentos;</li>
          <li>El alquiler de aparatos de cocción;</li>
          <li>El alquiler de sillas, mesas, mantelería y cristalería;</li>
          <li>Los servicios de bares de shisha;</li>
          <li>Los servicios de chefs de cocina a domicilio.</li>
        </ul>
        <h4>Clase 44</h4>
        <ul class="browser-default">
          <li>Los servicios hospitalarios;</li>
          <li>Los servicios de telemedicina;</li>
          <li>Los servicios de odontología, optometría y salud mental;</li>
          <li>Los servicios de clínicas médicas y los servicios de análisis médicos prestados por laboratorios médicos con fines diagnósticos y terapéuticos, tales como los exámenes radiográficos y las extracciones de sangre;</li>
          <li>Los servicios terapéuticos, por ejemplo: la fisioterapia y logopedia;</li>
          <li>El asesoramiento en materia de farmacia y la preparación de recetas médicas por farmacéuticos;</li>
          <li>Los servicios de bancos de sangre y los servicios de bancos de tejidos humanos;</li>
          <li>Los servicios de casas de convalecencia y de casas de reposo;</li>
          <li>El asesoramiento sobre dietética y nutrición;</li>
          <li>Los servicios de estaciones termales;</li>
          <li>Los servicios de inseminación artificial y de fecundación in vitro;</li>
          <li>La cría de animales;</li>
          <li>El aseo de animales;</li>
          <li>La perforación corporal y los servicios de tatuaje;</li>
          <li>Los servicios en relación con la jardinería, por ejemplo: los servicios de viveros, el diseño de parques y jardines, los servicios de jardineros paisajistas, el mantenimiento del césped;</li>
          <li>Los servicios en relación con el arte floral, por ejemplo: los arreglos florales, la confección de coronas;</li>
          <li>La eliminación de malas hierbas, los servicios de control de plagas para la agricultura, la acuicultura, la horticultura y la silvicultura.</li>
        </ul>
        <h4>Clase 45</h4>
        <ul class="browser-default">
          <li>Los servicios prestados por juristas, asistentes jurídicos y abogados asesores, a personas, grupos de personas, organizaciones o empresas;</li>
          <li>Los servicios de investigación y vigilancia en relación con la seguridad física de bienes materiales y personas;</li>
          <li>Los servicios prestados a personas en relación con acontecimientos sociales, tales como los servicios de acompañamiento en sociedad, los servicios de agencias matrimoniales y los servicios funerarios.</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="container" v-if="$i18n.locale == 'en'">
    <div class="row">
      <div class="col s12 left-align">
        <h3>
          NICE CLASSIFICATION - 11 Edition, Version 2021 - WIPO
        </h3>
        <h3>
          <span id="Prodotti-Classi-Nizza">List of Classes</span>
        </h3>
        <h4>Class 1</h4>
        <ul class="browser-default">
          <li>
            Sensitized paper;
          </li>
          <li>
            Tyre repairing compositions;
          </li>
          <li>
            Salt for preserving, other than for foodstuffs;
          </li>
          <li>
            Certain additives for use in the food industry, for example, pectin, lecithin, enzymes and chemical preservatives;
          </li>
          <li>
            Certain ingredients for use in the manufacture of cosmetics and pharmaceuticals, for example, vitamins, preservatives and antioxidants;
          </li>
          <li>
            Certain filtering materials, for example, mineral substances, vegetable substances and ceramic materials in particulate form.
          </li>
        </ul>
        <h4>Class 2</h4>
        <ul class="browser-default">
          <li>Paints, varnishes and lacquers for industry, handicrafts and arts;</li>
          <li>Thinners, thickeners, fixatives and siccatives for paints, varnishes and lacquers;</li>
          <li>Mordants for wood and leather;</li>
          <li>Anti-rust oils and oils for the preservation of wood;</li>
          <li>Dyestuffs for clothing;</li>
          <li>Colorants for foodstuffs and beverages.</li>
        </ul>
        <h4>Class 3</h4>
        <ul class="browser-default">
          <li>Sanitary preparations being toiletries;</li>
          <li>Tissues impregnated with cosmetic lotions;</li>
          <li>Deodorants for human beings or for animals;</li>
          <li>Room fragrancing preparations;</li>
          <li>Nail art stickers;</li>
          <li>Polishing wax;</li>
          <li>Sandpaper.</li>
        </ul>
        <h4>Class 4</h4>
        <ul class="browser-default">
          <li>Oils for the preservation of masonry or of leather;</li>
          <li>Raw wax, industrial wax;</li>
          <li>Electrical energy;</li>
          <li>Motor fuels, biofuels;</li>
          <li>Non-chemical additives for fuels;</li>
          <li>Wood for use as fuel.</li>
        </ul>
        <h4>Class 5</h4>
        <ul class="browser-default">
          <li>Sanitary preparations for personal hygiene, other than toiletries;</li>
          <li>Diapers for babies and for incontinence;</li>
          <li>Deodorants, other than for human beings or for animals;</li>
          <li>Medicated shampoos, soaps, lotions and dentifrices;</li>
          <li>Dietary supplements intended to supplement a normal diet or to have health benefits;</li>
          <li>Meal replacements and dietetic food and beverages adapted for medical or veterinary use.</li>
        </ul>
        <h4>Class 6</h4>
        <ul class="browser-default">
          <li>Metals in foil or powder form for further processing, for example, for 3D printers;</li>
          <li>Metal building materials, for example, materials of metal for railway tracks, pipes and tubes of metal;</li>
          <li>Small items of metal hardware, for example, bolts, screws, nails, furniture casters, window fasteners;</li>
          <li>Transportable buildings or structures of metal, for example, prefabricated houses, swimming pools, cages for wild animals, skating rinks;</li>
          <li>Certain goods made of common metals not otherwise classified by function or purpose, for example, all-purpose boxes of common metal, statues, busts and works of art of common metal.</li>
        </ul>
        <h4>Class 7</h4>
        <ul class="browser-default">
          <li>Parts of motors and engines of all kinds, for example, starters, mufflers and cylinders for motors and engines of any type;</li>
          <li>Electric cleaning and polishing apparatus, for example, electric shoe polishers, electric machines and apparatus for carpet shampooing and vacuum cleaners;</li>
          <li>3D printers;</li>
          <li>Industrial robots;</li>
          <li>Certain special vehicles not for transportation purposes, for example, road sweeping machines, road making machines, bulldozers, snow ploughs, as well as rubber tracks as parts of those vehicles' crawlers.</li>
        </ul>
        <h4>Class 8</h4>
        <ul class="browser-default">
          <li>Hand-operated agricultural, gardening and landscaping tools;</li>
          <li>Hand-operated tools for carpenters, artists and other craftspersons, for example, hammers, chisels and gravers;</li>
          <li>Handles for hand-operated hand tools, such as knives and scythes;</li>
          <li>Electric and non-electric hand implements for personal grooming and body art, for example, razors, implements for hair curling, tattooing, and for manicure and pedicure;</li>
          <li>Hand-operated pumps;</li>
          <li>Table cutlery, such as knives, forks and spoons, including those made of precious metals</li>
        </ul>
        <h4>Class 9</h4>
        <ul class="browser-default">
          <li>Apparatus and instruments for scientific research in laboratories;</li>
          <li>Training apparatus and simulators, for example, resuscitation mannequins, simulators for the steering and control of vehicles;</li>
          <li>Apparatus and instruments for controlling and monitoring aircraft, watercraft and unmanned vehicles, for example, navigational instruments, transmitters, compasses for measuring, GPS apparatus, automatic steering apparatus for vehicles;</li>
          <li>Safety and security apparatus and instruments, for example, safety nets, signalling lights, traffic-light apparatus, fire engines, sound alarms, security tokens being encryption devices;</li>
          <li>Clothing that protects against serious or life-threatening injuries, for example, clothing for protection against accidents, irradiation and fire, bullet-proof clothing, protective helmets, head guards for sports, mouth guards for sports, protective suits for aviators, knee-pads for workers;</li>
          <li>Optical apparatus and instruments, for example, eyeglasses, contact lenses, magnifying glasses, mirrors for inspecting work, peepholes;</li>
          <li>Magnets;</li>
          <li>Smartwatches, wearable activity trackers;</li>
          <li>Joysticks for use with computers, other than for video games, virtual reality headsets, smartglasses;</li>
          <li>Eyeglass cases, cases for smartphones, cases especially made for photographic apparatus and instruments;</li>
          <li>Automated teller machines, invoicing machines, material testing instruments and machines;</li>
          <li>Batteries and chargers for electronic cigarettes;</li>
          <li>Electric and electronic effects units for musical instruments;</li>
          <li>Laboratory robots, teaching robots, security surveillance robots, humanoid robots with artificial intelligence.</li>
        </ul>
        <h4>Class 10</h4>
        <ul class="browser-default">
          <li>Support bandages, orthopaedic bandages;</li>
          <li>Special clothing for medical purposes, for example, compression garments, stockings for varices, strait jackets, orthopaedic footwear;</li>
          <li>Articles, instruments and devices for menstruation, contraception and childbirth, for example, menstrual cups, pessaries, condoms, childbirth mattresses, forceps;</li>
          <li>Therapeutic and prosthetic articles and devices for implantation made of artificial or synthetic materials, for example, surgical implants comprised of artificial materials, artificial breasts, brain pacemakers, biodegradable bone fixation implants;</li>
          <li>Furniture especially made for medical purposes, for example, armchairs for medical or dental purposes, air mattresses for medical purposes, operating tables.</li>
        </ul>
        <h4>Class 11</h4>
        <ul class="browser-default">
          <li>Air-conditioning apparatus and installations;</li>
          <li>Ovens, other than for laboratory use, for example, dental ovens, microwave ovens, bakers' ovens;</li>
          <li>Stoves being heating apparatus;</li>
          <li>Solar thermal collectors;</li>
          <li>Chimney flues, chimney blowers, hearths, domestic fireplaces;</li>
          <li>Sterilizers, incinerators;</li>
          <li>Lighting apparatus and installations, for example, luminous tubes for lighting, searchlights, luminous house numbers, vehicle reflectors, lights for vehicles;</li>
          <li>Lamps, for example, electric lamps, gas lamps, laboratory lamps, oil lamps, street lamps, safety lamps;</li>
          <li>Tanning apparatus being sun beds;</li>
          <li>Bath installations, bath fittings, bath plumbing fixtures;</li>
          <li>Toilets, urinals;</li>
          <li>Fountains, chocolate fountains;</li>
          <li>Electrically heated pads, cushions and blankets, not for medical purposes;</li>
          <li>Hot water bottles;</li>
          <li>Electrically heated clothing;</li>
          <li>Electric appliances for making yogurt, bread-making machines, coffee machines, ice-cream making machines;</li>
          <li>Ice machines and apparatus.</li>
        </ul>
        <h4>Class 12</h4>
        <ul class="browser-default">
          <li>motors and engines for land vehicles;</li>
          <li>couplings and transmission components for land vehicles;</li>
          <li>air cushion vehicles;</li>
          <li>remote control vehicles, other than toys;</li>
          <li>parts of vehicles, for example, bumpers, windscreens, steering wheels, tyres for vehicle wheels, as well as treads for vehicles.</li>
        </ul>
        <h4>Class 13</h4>
        <ul class="browser-default">
          <li>Rescue flares, explosive or pyrotechnic;</li>
          <li>Flare pistols;</li>
          <li>Sprays for personal defence purposes;</li>
          <li>Explosive fog signals, signal rocket flares;</li>
          <li>Air pistols being weapons;</li>
          <li>Bandoliers for weapons;</li>
          <li>Sporting firearms, hunting firearms.</li>
        </ul>
        <h4>Class 14</h4>
        <ul class="browser-default">
          <li>Precious metals and their alloys; jewellery, precious and semi-precious stones; </li>
          <li>jewellery, including imitation jewellery, for example, paste jewellery;</li>
          <li>cuff links, tie pins, tie clips;</li>
          <li>key rings, key chains and charms therefor;</li>
          <li>jewellery charms;</li>
          <li>jewellery boxes;</li>
          <li>component parts for jewellery, clocks and watches, for example, clasps and beads for jewellery, movements for clocks and watches, clock hands, watch springs, watch crystals.</li>
        </ul>
        <h4>Class 15</h4>
        <ul class="browser-default">
          <li>Mechanical musical instruments and their accessories, for example, barrel organs, mechanical pianos, intensity regulators for mechanical pianos, robotic drums;</li>
          <li>Musical boxes;</li>
          <li>Electrical and electronic musical instruments;</li>
          <li>Strings, reeds, pegs and pedals for musical instruments;</li>
          <li>Tuning forks, tuning hammers;</li>
          <li>Colophony (rosin) for stringed musical instruments.</li>
        </ul>
        <h4>Class 16</h4>
        <ul class="browser-default">
          <li>Paper knives and paper cutters;</li>
          <li>Cases, covers and devices for holding or securing paper, for example, document files, money clips, holders for cheque books, paper-clips, passport holders, scrapbooks;</li>
          <li>Certain office machines, for example, typewriters, duplicators, franking machines for office use, pencil sharpeners;</li>
          <li>Painting articles for use by artists and interior and exterior painters, for example, artists' watercolour saucers, painters' easels and palettes, paint rollers and trays;</li>
          <li>Certain disposable paper products, for example, bibs, handkerchiefs and table linen of paper;</li>
          <li>Certain goods made of paper or cardboard not otherwise classified by function or purpose, for example, paper bags, envelopes and containers for packaging, statues, figurines and works of art of paper or cardboard, such as figurines of papier mâché, framed or unframed lithographs, paintings and watercolours.</li>
        </ul>
        <h4>Class 17</h4>
        <ul class="browser-default">
          <li>Rubber material for recapping tyres;</li>
          <li>Floating anti-pollution barriers;</li>
          <li>Adhesive tapes, other than stationery and not for medical or household purposes;</li>
          <li>Plastic films, other than for wrapping and packaging, for example, anti-dazzle films for windows;</li>
          <li>Elastic threads and threads of rubber or plastic, not for textile use;</li>
          <li>Certain goods made of the materials in this class not otherwise classified by function or purpose, for example, foam supports for flower arrangements, padding and stuffing materials of rubber or plastics, rubber stoppers, shock-absorbing buffers of rubber, rubber bags or envelopes for packaging.</li>
        </ul>
        <h4>Class 18</h4>
        <ul class="browser-default">
          <li>Luggage and carrying bags, for example, suitcases, trunks, travelling bags, sling bags for carrying infants, school bags;</li>
          <li>Luggage or baggage tags;</li>
          <li>Business card cases and pocket wallets;</li>
          <li>Boxes and cases of leather or leatherboard.</li>
        </ul>
        <h4>Class 19</h4>
        <ul class="browser-default">
          <li>Semi-worked woods for use in building, for example, beams, planks, panels;
            wood veneers;</li>
          <li>Building glass, for example, glass tiles, insulating glass for building, safety glass;</li>
          <li>Glass granules for marking out roads;</li>
          <li>Granite, marble, gravel;</li>
          <li>Terra-cotta for use as a building material;</li>
          <li>Roofing, not of metal, incorporating photovoltaic cells;</li>
          <li>Gravestones and tombs, not of metal;</li>
          <li>Statues, busts and works of art of stone, concrete or marble;</li>
          <li>Letter boxes of masonry;</li>
          <li>Geotextiles;</li>
          <li>Coatings being building materials;</li>
          <li>Scaffolding, not of metal;</li>
          <li>Transportable buildings or structures, not of metal, for example, aquaria, aviaries, flagpoles, porches, swimming pools.</li>
        </ul>
        <h4>Class 20</h4>
        <ul class="browser-default">
          <li>Metal furniture, furniture for camping, gun racks, newspaper display stands;</li>
          <li>Indoor window blinds and shades;</li>
          <li>Bedding, for example, mattresses, bed bases, pillows;</li>
          <li>Looking glasses, furniture and toilet mirrors;</li>
          <li>Registration plates, not of metal;</li>
          <li>Small items of hardware, not of metal, for example, bolts, screws, dowels, furniture casters, collars for fastening pipes;</li>
          <li>Letter boxes, not of metal or masonry.</li>
        </ul>
        <h4>Class 21</h4>
        <ul class="browser-default">
          <li>Household and kitchen utensils, for example, fly swatters, clothes-pegs, mixing spoons, basting spoons and corkscrews, as well as serving utensils, for example, sugar tongs, ice tongs, pie servers and serving ladles;</li>
          <li>Household, kitchen and cooking containers, for example, vases, bottles, piggy banks, pails, cocktail shakers, cooking pots and pans, and non-electric kettles and pressure cookers;</li>
          <li>Small hand-operated kitchen apparatus for mincing, grinding, pressing or crushing, for example, garlic presses, nutcrackers, pestles and mortars;</li>
          <li>Dish stands and decanter stands;</li>
          <li>Cosmetic and toilet utensils, for example, electric and non-electric combs and toothbrushes, dental floss, foam toe separators for use in pedicures, powder puffs, fitted vanity cases;</li>
          <li>Gardening articles, for example, gardening gloves, window-boxes, watering cans and nozzles for watering hose;</li>
          <li>Indoor aquaria, terrariums and vivariums</li>
        </ul>
        <h4>Class 22</h4>
        <ul class="browser-default">
          <li>Cords and twines made of natural or artificial textile fibres, paper or plastics;</li>
          <li>Fishing nets, hammocks, rope ladders;</li>
          <li>Vehicle covers, not fitted;</li>
          <li>Certain sacks and bags not otherwise classified by function or purpose, for example, mesh bags for washing laundry, body bags, mail bags;</li>
          <li>Packaging bags of textile;</li>
          <li>Animal fibres and raw textile fibres, for example, animal hair, cocoons, jute, raw or treated wool, raw silk.</li>
        </ul>
        <h4>Class 23</h4>
        <ul class="browser-default">
          <li>Fibreglass, elastic, rubber and plastic threads for textile use;</li>
          <li>Threads for embroidery, darning and sewing, including those of metal;</li>
          <li>Spun silk, spun cotton, spun wool.</li>
        </ul>
        <h4>Class 24</h4>
        <ul class="browser-default">
          <li>Household linen, for example, bedspreads, pillow shams, towels of textile;</li>
          <li>Bed linen of paper;</li>
          <li>Sleeping bags, sleeping bag liners;</li>
          <li>Fosquito nets.</li>
        </ul>
        <h4>Class 25</h4>
        <ul class="browser-default">
          <li>Parts of clothing, footwear and headwear, for example, cuffs, pockets, ready-made linings, heels and heelpieces, cap peaks, hat frames (skeletons);</li>
          <li>Clothing and footwear for sports, for example, ski gloves, sports singlets, cyclists' clothing, judo and karate uniforms, football shoes, gymnastic shoes, ski boots;</li>
          <li>Masquerade costumes;</li>
          <li>Paper clothing, paper hats for use as clothing;</li>
          <li>Bibs, not of paper;</li>
          <li>Pocket squares;</li>
          <li>Footmuffs, not electrically heated.</li>
        </ul>
        <h4>Class 26</h4>
        <ul class="browser-default">
          <li>Wigs, toupees, false beards;</li>
          <li>Barrettes, hair bands</li>
          <li>Ribbons and bows being haberdashery or used as hair decorations, made of any material;</li>
          <li>Ribbons and bows for gift wrapping, not of paper;</li>
          <li>Hair nets;</li>
          <li>Buckles, zippers;</li>
          <li>Charms, other than for jewellery, key rings or key chains;</li>
          <li>Artificial Christmas garlands and wreaths, including those incorporating lights;</li>
          <li>Certain articles for curling hair, for example, electric and non-electric hair curlers, other than hand implements, hair curling pins, hair curling paper.</li>
        </ul>
        <h4>Class 27</h4>
        <ul class="browser-default">
          <li>Automobile carpets;</li>
          <li>Mats being floor coverings, for example, bath mats, door mats, gymnastic mats, yoga mats;</li>
          <li>Artificial turf;</li>
          <li>Wallpaper, including textile wallpaper.</li>
        </ul>
        <h4>Class 28</h4>
        <ul class="browser-default">
          <li>Amusement and game apparatus, including controllers therefor;</li>
          <li>Novelty toys for playing jokes and for parties, for example, carnival masks, paper party hats, confetti, party poppers and Christmas crackers;</li>
          <li>Hunting and fishing tackle, for example, fishing rods, landing nets for anglers, decoys, hunting game calls;</li>
          <li>Equipment for various sports and games.</li>
        </ul>
        <h4>Class 29</h4>
        <ul class="browser-default">
          <li>Meat-, fish-, fruit- or vegetable-based food;</li>
          <li>Edible insects;</li>
          <li>Milk beverages with milk predominating;</li>
          <li>Milk substitutes, for example, almond milk, coconut milk, peanut milk, rice milk, soya milk;</li>
          <li>Preserved mushrooms;</li>
          <li>Pulses and nuts prepared for human consumption;</li>
          <li>Seeds prepared for human consumption, not being seasonings or flavourings.</li>
        </ul>
        <h4>Class 30</h4>
        <ul class="browser-default">
          <li>Beverages with coffee, cocoa, chocolate or tea base;</li>
          <li>Cereals prepared for human consumption, for example, oat flakes, corn chips, husked barley, bulgur, muesli;</li>
          <li>Pizza, pies, sandwiches;</li>
          <li>Chocolate-coated nuts;</li>
          <li>Flavourings, other than essential oils, for food or beverages.</li>
        </ul>
        <h4>Class 31</h4>
        <ul class="browser-default">
          <li>Unprocessed cereals;</li>
          <li>Fresh fruits and vegetables, even after washing or waxing;</li>
          <li>Plant residue;</li>
          <li>Unprocessed algae;</li>
          <li>Unsawn timber;</li>
          <li>Fertilised eggs for hatching;</li>
          <li>Fresh mushrooms and truffles;</li>
          <li>Litter for animals, for example, aromatic sand, sanded paper for pets.</li>
        </ul>
        <h4>Class 32</h4>
        <ul class="browser-default">
          <li>De-alcoholised beverages;</li>
          <li>Soft drinks;</li>
          <li>Rice-based and soya-based beverages, other than milk substitutes;</li>
          <li>Energy drinks, isotonic beverages, protein-enriched sports beverages;</li>
          <li>Non-alcoholic essences and fruit extracts for making beverages</li>
        </ul>
        <h4>Class 33</h4>
        <ul class="browser-default">
          <li>Wines, fortified wines;</li>
          <li>Alcoholic cider, perry;</li>
          <li>Spirits, liqueurs;</li>
          <li>Alcoholic essences, alcoholic fruit extracts, bitters.</li>
        </ul>
        <h4>Class 34</h4>
        <ul class="browser-default">
          <li>Tobacco substitutes, not for medical purposes;</li>
          <li>Flavourings, other than essential oils, for use in electronic cigarettes, oral vaporizers for smokers;</li>
          <li>Herbs for smoking;</li>
          <li>Snuff;</li>
          <li>Certain accessories and containers related to the use of tobacco and articles for smoking, for example, lighters for smokers, ashtrays for smokers, tobacco jars, snuff boxes, cigar humidors.</li>
        </ul>
        <h4>Class 35</h4>
        <ul class="browser-default">
          <li>The bringing together, for the benefit of others, of a variety of goods, excluding the transport thereof, enabling customers to conveniently view and purchase those goods; such services may be provided by retail stores, wholesale outlets, through vending machines, mail order catalogues or by means of electronic media, for example, through web sites or television shopping programmes;</li>
          <li>Advertising, marketing and promotional services, for example, distribution of samples, development of advertising concepts, writing and publication of publicity texts;</li>
          <li>Shop window dressing;</li>
          <li>Public relations services;</li>
          <li>Production of teleshopping programmes;</li>
          <li>Organization of trade fairs and exhibitions for commercial or advertising purposes;</li>
          <li>Search engine optimization for sales promotion;</li>
          <li>Commercial assistance services, for example, personnel recruitment, negotiation of business contracts for others, cost price analysis, import-export agency services</li>
          <li>Administration services relating to business transactions and financial records, for example, book-keeping, drawing up of statements of accounts, business and financial auditing, business appraisals, tax preparation and filing services;</li>
          <li>Commercial administration of the licensing of the goods and services of others;</li>
          <li>Services consisting of the registration, transcription, composition, compilation or systematization of written communications and registrations, and also the compilation of mathematical or statistical data;</li>
          <li>Office functions, for example, appointment scheduling and reminder services, data search in computer files for others, computerized file management, telephone switchboard services</li>
        </ul>
        <h4>Class 36</h4>
        <ul class="browser-default">
          <li>Financial transaction and payment services, for example, exchanging money, electronic funds transfer, processing of credit card and debit card payments, issuance of travellers' cheques;</li>
          <li>Financial management and research;</li>
          <li>Financial appraisals, for example, jewellery, art and real estate appraisal, repair costs evaluation;</li>
          <li>Cheque verification;</li>
          <li>Financing and credit services, for example, loans, issuance of credit cards, hire- or lease-purchase financing;</li>
          <li>Crowdfunding;</li>
          <li>Safe deposit services;</li>
          <li>Financial sponsorship;</li>
          <li>Real estate agency services, real estate management, rental of apartments, rent collection;</li>
          <li>Insurance underwriting, actuarial services;</li>
          <li>Brokerage services, for example, securities, insurance and real estate brokerage, brokerage of carbon credits, pawnbrokerage.</li>
        </ul>
        <h4>Class 37</h4>
        <ul class="browser-default">
          <li>construction and demolition of buildings, roads, bridges, dams or transmission lines, as well as services in the field of construction, for example, interior and exterior painting, plastering, plumbing, heating equipment installation, and roofing;</li>
          <li>shipbuilding;</li>
          <li>rental of construction tools, machines and equipment, for example, rental of bulldozers, rental of cranes;</li>
          <li>various repair services, for example, those in the fields of electricity, computer hardware, furniture, instruments, tools;</li>
          <li>various restoration services, for example, building restoration, furniture restoration and restoration of works of art;</li>
          <li>maintenance services for preserving an object in its original condition without changing any of its properties;</li>
          <li>cleaning of different objects, for example, windows, vehicles, clothing, as well as the laundering and pressing of clothing.</li>
        </ul>
        <h4>Class 38</h4>
        <ul class="browser-default">
          <li>transmission of digital files and electronic mail;</li>
          <li>providing user access to global computer networks;</li>
          <li>radio and television broadcasting;</li>
          <li>video-on-demand transmission;</li>
          <li>providing internet chatrooms and online forums;</li>
          <li>telephone and voice mail services;</li>
          <li>teleconferencing and videoconferencing services.</li>
        </ul>
        <h4>Class 39</h4>
        <ul class="browser-default">
          <li>operation of stations, bridges, railways, ferries and other transport facilities;</li>
          <li>rental of vehicles for transportation, as well as chauffeuring and piloting services;</li>
          <li>rental services related to transport, storage and travel, for example, parking place rental, garage rental, rental of storage containers;</li>
          <li>operation of maritime tugs, unloading, operation of ports and docks, and salvaging of wrecked ships and their cargoes;</li>
          <li>packaging, bottling, wrapping and delivering of goods;</li>
          <li>replenishing vending machines and automated teller machines;</li>
          <li>services for providing information about journeys or the transport of goods by brokers and tourist agencies, as well as for providing information relating to tariffs, timetables and methods of transport;</li>
          <li>inspection of vehicles or goods for the purpose of transport;</li>
            <li>distribution of energy and electricity, as well as distribution and supply of water.</li>
        </ul>
        <h4>Class 40</h4>
        <ul class="browser-default">
          <li>transformation of an object or substance and any process involving a change in its essential properties, for example, dyeing a garment; such transformation services are also classified in Class 40 if they are provided in the framework of repair or maintenance work, for example, chromium plating of motor vehicle bumpers;</li>
          <li>services of material treatment which may be present during the production of any substance or object other than a building, for example, services which involve cutting, shaping, polishing by abrasion or metal coating;</li>
          <li>joining of materials, for example, soldering or welding;</li>
          <li>processing and treatment of foodstuffs, for example, fruit crushing, flour milling, food and drink preservation, food smoking, freezing of foods;</li>
          <li>custom manufacturing of goods to the order and specification of others (bearing in mind that certain offices require that the goods produced be indicated), for example, custom manufacturing of automobiles;</li>
          <li>services of a dental technician;</li>
          <li>quilting, embroidering, custom tailoring, textile dyeing, applying finishes to textiles.</li>
        </ul>
        <h4>Class 41</h4>
        <ul class="browser-default">
          <li>organization of exhibitions for cultural or educational purposes, arranging and conducting of conferences, congresses and symposiums;</li>
          <li>translation and language interpretation services;</li>
          <li>publication of books and texts, other than publicity texts;</li>
          <li>news reporters services, photographic reporting;</li>
          <li>photography;</li>
          <li>film direction and production services, other than for advertising films;</li>
          <li>cultural, educational or entertainment services provided by amusement parks, circuses, zoos, art galleries and museums;</li>
          <li>sports and fitness training services;</li>
          <li>training of animals;</li>
          <li>online gaming services;</li>
          <li>gambling services, organization of lotteries;</li>
          <li>ticket reservation and booking services for entertainment, educational and sporting events;</li>
        <li>certain writing services, for example, screenplay writing, songwriting.</li>

        </ul>
        <h4>Class 42</h4>
        <ul class="browser-default">
         <li>services of engineers and scientists who undertake evaluations, estimates, research and reports in the scientific and technological fields, including technological consultancy;</li>
          <li>computer and technology services for securing computer data and personal and financial information and for the detection of unauthorized access to data and information, for example, computer virus protection services, data encryption services, electronic monitoring of personally identifying information to detect identity theft via the internet;</li>
          <li>software as a service (SaaS), platform as a service (PaaS);</li>
          <li>scientific research services for medical purposes;</li>
          <li>architectural and urban planning services;</li>
          <li>certain design services, for example, industrial design, design of computer software and systems, interior design, packaging design, graphic arts design, dress designing;</li>
          <li>surveying;</li>
          <li>oil, gas and mining exploration services.</li>

        </ul>
        <h4>Class 43</h4>
        <ul class="browser-default">
          <li>temporary accommodation reservations, for example, hotel reservations;</li>
          <li>boarding for animals;</li>
          <li>rental of meeting rooms, tents and transportable buildings;</li>
          <li>retirement home services;</li>
          <li>day-nursery and crèche services;</li>
          <li>decorating of food, food sculpting;</li>
          <li>rental of cooking apparatus;</li>
          <li>rental of chairs, tables, table linen, glassware;</li>
          <li>hookah lounge services;</li>
          <li>personal chef services.</li>
        </ul>
        <h4>Class 44</h4>
        <ul class="browser-default">
          <li>hospital services;</li>
          <li>telemedicine services;</li>
          <li>dentistry, optometry and mental health services;</li>
          <li>medical clinic services and medical analysis services for diagnostic and treatment purposes provided by medical laboratories, such as x-ray examinations and taking of blood samples</li>
          <li>therapy services, for example, physiotherapy and speech therapy;</li>
          <li>pharmacy advice and preparation of prescriptions by pharmacists;</li>
          <li>blood bank and human tissue bank services;</li>
          <li>convalescent home and rest home services;</li>
          <li>dietary and nutritional advice;</li>
          <li>health spa services;</li>
          <li>artificial insemination and in vitro fertilization services;</li>
          <li>animal breeding;</li>
          <li>animal grooming;</li>
          <li>body piercing and tattooing;</li>
          <li>services relating to gardening, for example, plant nursery services, landscape design, landscape gardening, lawn care;</li>
          <li>services relating to floral art, for example, flower arranging, wreath making;</li>
          <li>weed killing, vermin and pest control for agriculture, aquaculture, horticulture and forestry.</li>

        </ul>
        <h4>Class 45</h4>
        <ul class="browser-default">
          <li>services rendered by lawyers, legal assistants, and personal advocates, to individuals, groups of individuals, organizations and enterprises;</li>
          <li>investigation and surveillance services relating to the physical safety of persons and security of tangible property;</li>
          <li>services provided to individuals in relation with social events, such as social escort services, matrimonial agencies, funeral services.</li>
        </ul>
      </div>
    </div>
  </div>

</template>

<script>
export default {

}
</script>

<style>

</style>
